exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".set-url[data-v-142530ab]{max-width:1200px;margin:10px auto 40px}.set-url .form-box[data-v-142530ab]{padding:40px 80px 60px 0;max-width:1000px}.set-url .form-box .display_class[data-v-142530ab]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.set-url .form-box .display_class .submit[data-v-142530ab]{margin-left:20px}.set-url .form-box .display_class .el-form-item[data-v-142530ab],.set-url .form-box .display_class .el-form-item[data-v-142530ab] .el-form-item__content{height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-142530ab","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/ent-access/setUrl.vue
// module id = /6X2
// module chunks = 48